angular.module('IndicatorTree').controller('IndicatorTreeController', [
  '$scope',
  '$filter',
  '$sce',
  '$uibModal',
  function ($scope, $filter, $sce, $uibModal, $q) {
    $scope.treeFilter = $filter('uiTreeFilter');
    $scope.showSelection = false;
    $scope.selectItem = function (item) {
      $scope.selectedItem = item;
      $scope.showSelection = false;
    };

    $scope.toggleSelection = function() {
      $scope.showSelection = !$scope.showSelection;
    };
  }
]);
